import { ActionService } from './../../actions/action.service';
import { ActionDTO, OrganizationalUnitDTO, TaskDTO } from './../../api/plyca-dtos';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, AfterContentInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { generateRandomIdentifier } from '../../ui.service';
import { UserDTO } from '../../api/plyca-dtos';
import { PropertyService } from '../../properties/property.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { catchError, finalize, map, take } from 'rxjs/operators';
import * as lodash from 'lodash';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../auth.service';
import { HelpType } from '../../components/common/help/help.service';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { UserService } from '../../user.service';

export class OrganizationalUnitModel {

  dto: OrganizationalUnitDTO;
  ui: any;
}

@Component({
  selector: 'orgs-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html',
  providers: [DialogService]
})
export class OrganizationalUnitEditionComponent
  extends BaseFormComponent<OrganizationalUnitDTO, OrganizationalUnitModel>
  implements OnInit, AfterContentInit, OnDestroy {


  private identifier: string;
  readonly = false;
  operation: string;
  private properties = {};


  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private propertyService: PropertyService,
    private plycaErrorHandler: PlycaErrorHandler,
    private userService: UserService,
    private actionService: ActionService,
    private _http: HttpClient,
    private _authService: AuthService,

    @Optional() protected activatedRoute: ActivatedRoute

  ) {
    super(elem);
    this.identifier = dialogConfig['id'];
    this.operation = dialogConfig['operation'];
    this.readonly = this.operation && this.operation == 'show';
    this.windowHash = generateRandomIdentifier();

  }

  ngOnInit(): void {
    this.subscribe(

      forkJoin([
        this.propertyService.getProperty('VALIDITY_PERIOD_ORGANIZATIONALUNIT_ENABLED', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          })),

        this.propertyService.getProperty('PUBLICAR_ORGANISMO_EN_PORTAL', 'NO')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        ,



      ]).pipe(
        map(

          (prop: any[]) => {

            this.properties['VALIDITY_PERIOD_ORGANIZATIONALUNIT_ENABLED'] = prop[0] == '1';
            this.properties['PUBLICAR_ORGANISMO_EN_PORTAL'] = prop[1] == 'SI';


          }),
        finalize(() => {

          super.ngOnInit();

        })
      )

    )
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }



  ngAfterContentInit(): void {



  }

  getFormSettingURL(): string {
    return 'admin/organizationalunitISettings.json';
  }

  getServiceURL(operation?: string): string {

    if (operation === 'copy' || operation === 'insert' || operation === 'update') {
      return this.configuration.ADMIN_ORGANIZATIONUNIT_SERVICE_URL;
    } else {
      return this.configuration.ORGANIZATIONUNIT_SERVICE_URL;
    }

  }
  getObjectParams(): { [param: string]: string | string[]; } {
    if (this.identifier === 'new') {
      return {};
    } else {
      return {

        //'expand': 'entityDTO,unitParent,customFields,entityDTO.customFields,expansionSet:addresses'
        'expand': 'expansionSet:manage'

      };
    }

  }

  getObjectIdentifier(): string {
    return this.identifier;
  }


  dtoToModel(dto: OrganizationalUnitDTO): Observable<any> {
    let model = new OrganizationalUnitModel();
    // inicializacion de los campos del modelo utilizados por el json

    model.dto = dto;
    if (this.operation == 'copy') {
      model.dto.identifier = undefined;

    }



    model['ui'] = {};
    model.ui['properties'] = {};

    model.ui.properties = this.properties;
    if (this.operation == 'insert' || this.operation == 'insert') {




    }
    model.ui['operation'] = this.operation;
    let params: any = {};



    return of(model);


  }



  modelToDTO(model: OrganizationalUnitModel): OrganizationalUnitDTO {


    let dto: OrganizationalUnitDTO;
    dto = lodash.cloneDeep(model.dto);

    delete dto.customFieldDefinitions;
    delete dto.links;
    delete dto.entityDTO;
    delete dto['extendedDataIdentifier'];
    //delete dto['addresses'];
    delete dto?.unitParent?.customFields;

    if (!dto.entity) {
      delete dto?.customFields?.ORG_NUTS_STD;
      // atributo a nivel organismo
      //delete dto?.customFields?.ORG_ES_CENTRAL_COMPRAS_STD;
      delete dto?.customFields?.ORG_ACTIVIDAD_PRINC_STD;
    } else {
      if (dto?.customFields?.ORG_NUTS_STD === true) {
        dto.customFields.ORG_NUTS_STD = 1
      } else {
        if (!dto?.customFields) {
          dto.customFields = {}
        }
        if (!dto?.customFields?.ORG_NUTS_STD) {
          dto.customFields.ORG_NUTS_STD = {}
        }
        dto.customFields.ORG_NUTS_STD = 0
      }


    }
    if (dto?.customFields?.ORG_ES_CENTRAL_COMPRAS_STD === true) {
      dto.customFields.ORG_ES_CENTRAL_COMPRAS_STD = 1
    } else {
      if (!dto?.customFields) {
        dto.customFields = {}
      }
      if (!dto?.customFields?.ORG_ES_CENTRAL_COMPRAS_STD) {
        dto.customFields.ORG_ES_CENTRAL_COMPRAS_STD = {}
      }
      dto.customFields.ORG_ES_CENTRAL_COMPRAS_STD = 0
    }


    dto = JSON.parse(
      JSON.stringify(dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    return dto;

  }




  initHeaderActions() {
    if (this.readonly && this.properties['PUBLICAR_ORGANISMO_EN_PORTAL']) {

      this.subscribe(this.plycaService
        .getAvailableAction('ORGANIZATIONALUNIT_PUBLISH', this.model.dto.identifier, 'ORGANIZATIONALUNIT')
        .pipe(

          finalize(() => {
            this.configureButtons();
            // this.waitService.cancelWaiting(); // Al finalizar (ok o con error)  se cancela la capa de espera.
          })),

        (datos: any) => {
          if (datos && datos.actions) {
            datos.actions.forEach(action => {


              this.subscribe(this.headerActionsService.addWindowAction(
                action.name,
                this.actionService.getActionIconClass(action),
                'btn-secondary',
                true, this.windowHash)
                , success => {
                  this.openModalAction(action, this.task).onClose.pipe(take(1)).subscribe(() => console.log('ejecutada'));
                });
            });
          }
        });



    } else {
      this.configureButtons();
    }

  }
  configureButtons() {
    if (this.readonly) {

      this.subscribe(this.headerActionsService
        .addWindowAction('General.close', 'fas fa-times', 'btn-outline-secondary',
          true, this.windowHash),

        (success) => {

          this.cancel();


        });
    } else {



      this.subscribe(this.headerActionsService
        .addWindowAction('General.save', 'fas fa-save', 'btn-primary',
          true, this.windowHash),

        (success) => {
          /*
                    this.uiService.showSuccess(
                      'Operación no implementada',
                      this.translate.instant('General.info'),
                      'warn'
                    );
          */
          if (this.operation == 'insert') {
            this.subscribe(this.insert(),
              (newObject: OrganizationalUnitDTO) => {
                this.waitService.cancelWaiting();
                this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
                  'success');
                this.ref.close(true);
              },
              (err) => {
                this.waitService.cancelWaiting();
                this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
                  'error');
                // Revisar ¿error de validación? Error 404
                // this.plycaErrorHandler.showServerError(err);
              })
          } else if (this.operation == 'update') {
            this.subscribe(this.update(),
              (newObject: OrganizationalUnitDTO) => {
                this.waitService.cancelWaiting();
                this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
                  'success');
                this.ref.close(true);
              },
              (err) => {
                this.waitService.cancelWaiting();
                this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
                  'error');
                // Revisar ¿error de validación? Error 404
                // this.plycaErrorHandler.showServerError(err);
              })

          }

        }
      );

      this.subscribe(this.headerActionsService
        .addWindowAction('General.cancel', 'fas fa-times', 'btn-outline-secondary',
          true, this.windowHash),

        (success) => {

          this.cancel();


        });


    }
  }

  confirmUpdate() {
    setTimeout(() => {
      this.confirmationService.confirm({
        message: this.translationService.instant('ControlPanel.users.confirm.update'),
        accept: () => {

          this.updateUser();

        }
      });
    }, 200);
  }



  updateUser() {
    this.subscribe(this.update(),
      (newUser: UserDTO) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
          'success');
        this.ref.close(newUser);
      },
      (err) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
          'error');
        // Revisar ¿error de validación? Error 404
        // this.plycaErrorHandler.showServerError(err);
      })
  }

  public enablePasswordButton(): boolean {
    return !this.model.ui.changePassword;
  }


  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.windowHash = this.windowHash;
    formConfig.readonly = this.readonly;
    formConfig.searchTags = [HelpType.EDIT_ORGS];


    formConfig.functions.push({
      identifier: 'setPreUID',
      fn: this.setPreUID  // Para tener acceso al documentService
    });
    formConfig.functions.push({
      identifier: 'clearEntityCustomFields',
      fn: this.clearEntityCustomFields  // Para tener acceso al documentService
    });



    return of(formConfig);
  }


  setPreUID(model: any) {
    if (model.ui.operation == 'insert') {
      model.dto.unitId = model.dto.unitParent.unitId + '...';
      model.dto.headLine1 = model.dto.unitParent.headLine1;
      model.dto.headLine2 = model.dto.unitParent.headLine2;
      model.dto.headLine3 = model.dto.unitParent.headLine3;
      model.dto.headLine4 = model.dto.unitParent.headLine4;
    }



  }

  clearEntityCustomFields(model: any) {
    if (!model.dto.entity) {
      if (model.dto?.customFields?.ORG_NUTS_STD) {
        model.dto.customFields.ORG_NUTS_STD = false;
      }
      /* atributo a nivel de organismo
      if (model.dto?.customFields?.ORG_ES_CENTRAL_COMPRAS_STD) {
        model.dto.customFields.ORG_ES_CENTRAL_COMPRAS_STD = false;
      }*/
      if (model.dto?.customFields?.ORG_ACTIVIDAD_PRINC_STD) {
        model.dto.customFields.ORG_ACTIVIDAD_PRINC_STD = '';
      }



    }



  }



  modalError(error) {
    // this.ref.close();
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }


  public cancel() {
    this.uiService.showSuccess(
      this.translate.instant('General.msg.cancel'),
      this.translate.instant('General.info'),
      'warn'
    );
    this.ref.close(false);

  }
  public noImplemented() {
    this.uiService.showSuccess(
      'Operación no implementada',
      this.translate.instant('General.info'),
      'warn'
    );

  }

  getHeaderInfo(): BaseFormHeaderInfo {
    throw new Error('Method not implemented.');
  }



  getStringID(identifier: string) {
    let des = '';
    if (typeof identifier === 'string' && identifier.indexOf('<>') !== -1) {
      des = identifier.toString().substring(identifier.indexOf('>') + 1, identifier.length);
    }
    return des;
  }



  openModalAction(action: ActionDTO, task: TaskDTO) {

    let config: DynamicDialogConfig = {
      header: action.name,

      width: '60%',
      styleClass: 'actionStyle',
      style: { overflow: 'hidden' }


    };
    config['action'] = action;
    config['dto'] = this.model.dto;
    /*
        action.parameters.find((a) => a.name == 'DIVISION').value = this.loteid;
        action.parameters.find((a) => a.name == 'PROPUESTAID').value = this.dossierId;
        action.parameters.find((a) => a.name == 'TASKID').value = task.identifier;
        action.parameters.find((a) => a.name == 'TASKID').editable = false;
        action.parameters.find((a) => a.name == 'DIVISION').editable = false;
        action.parameters.find((a) => a.name == 'PROPUESTAID').editable = false;

    */


    return this.dialogService.open(ActionsProcessComponent, config);


  }





}
